import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";
import { getI18n } from "react-i18next";

export const languageSliceName = "language";

export interface LanguageState {
  availableLanguages: string[];
  selectedLanguage: string;
}

export const DEFAULT_LANGUAGE = "en";

const persistedLanguage = localStorage.getItem(languageSliceName);
const persistedState = persistedLanguage ? JSON.parse(persistedLanguage) : null;
const initialLanguage: string = persistedState ?? DEFAULT_LANGUAGE;
const initialState: LanguageState = {
  availableLanguages: [],
  selectedLanguage: initialLanguage,
};

const languageSlice = createSlice({
  name: languageSliceName,
  initialState,
  reducers: {
    setLanguage(state: LanguageState, action: PayloadAction<string>) {
      state.selectedLanguage = action.payload;
    },
    setAvailableLanguages(state: LanguageState, action: PayloadAction<string[]>) {
      state.availableLanguages = action.payload;
    },
  },
});

export interface LanguageRootState {
  [languageSliceName]: LanguageState;
}

export const selectLanguage = (state: LanguageRootState) => state[languageSliceName];
export const setLanguage = (language: string) => (dispatch: Dispatch) => {
  getI18n().changeLanguage(language).then(() => console.log(`INFO: changed language to ${language}`));
  localStorage.setItem(languageSliceName, JSON.stringify(language));
  dispatch(languageSlice.actions.setLanguage(language));
};

export const { setAvailableLanguages, setLanguage: setLanguageAction } = languageSlice.actions;
export const languageReducer = languageSlice.reducer;
